<template>
    <v-card>
        <v-toolbar flat dark color="primary">
            <v-toolbar-title>{{ isNew ? 'Aggiungi nuovo task' : 'Modifica task' }}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-btn v-if="!disabled && !isNewEntry" @click="confirmDelete" color="error" rounded small><v-icon
                    left>delete</v-icon>Elimina</v-btn>
        </v-toolbar>
        <v-card-text>
            <v-form v-model="validForm">
                <v-text-field v-model="data.name" :rules="rules.name" label="Nome task" required
                    v-bind="{ loading, disabled }"></v-text-field>
                <v-text-field v-model="data.description" :rules="rules.description" label="Descrizione task" required
                    v-bind="{ loading, disabled }"></v-text-field>
                <v-text-field v-model="data.date_start" :rules="rules.date_start" type="date" label="Data inizio"
                    required v-bind="{ loading, disabled }" />
                <v-text-field v-model="data.date_end" :rules="rules.date_end" type="date" label="Data fine" required
                    v-bind="{ loading, disabled }" />
                <v-switch v-model="data.active" label="Attivo" v-bind="{ loading, disabled }" />
            </v-form>
            <sals-list v-model="data" v-bind="{ disabled, loading }" class="my-6"></sals-list>

            <subtask-resources-editor :value="data.resources" v-bind="{ disabled, loading, showPrices, permissions, user }" />
        </v-card-text>
        <v-card-actions>
            <v-btn @click="$emit('close')"><v-icon left>close</v-icon>Chiudi</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="!disabled" @click="save" :disabled="!canSubmit" color="primary"><v-icon
                    left>save</v-icon>Salva</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import { Vuelidator, Rule } from '../../Vuelidator/index.js';
import SubtaskResourcesEditor from './SubtaskResourcesEditor.vue';
import SalsList from './SalsList.vue';
import { NormalizeSubTask } from './ProjectUtils.js';

export default {
    props: {
        value: { type: Object, required: false },
        loading: { default: false, },
        disabled: { default: false, },
        showPrices: { type: Boolean, default: true },
        permissions: {type: Array, default:[]},
        user:{type:Object, required: true},
    },
    data() {
        const data = NormalizeSubTask(this.value);
        const validator = new Vuelidator({
            name: [Rule.required(), Rule.min(3)],
            description: [Rule.nullable(), Rule.min(3)],
            date_start: [Rule.required(), Rule.date()],
            date_end: [Rule.required(), Rule.date()],
        });
        const rules = validator.getRules();

        return {
            validForm: false,
            data,
            rules,
        }
    },
    computed: {
        canSubmit() {
            return this.validForm;
        },
        isNew() {
            return !this.data.id;
        },
        isNewEntry() {
            return this.value.id === undefined;
        }
    },
    methods: {
        save() {
            this.$emit('save', this.data);
        },
        confirmDelete() {
            if (confirm('Confermi di voler cancellare il sottotask e tutte le informazioni associate?')) {
                this.$emit('delete', this.value);
            }
        },
    },
    watch: {
        value() {
            this.data = NormalizeSubTask(this.value);
        }
    },
    components: {
        SubtaskResourcesEditor,
        SalsList,
    },
}
</script>